export default __webpack_public_path__ + "static/assets/d259fcbecaa9d2a22d19848daff9d4c6.svg";